import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Volumepopup from "./VolumePopup.js";
import Liquiditypopup from "./LiquidityPopup.js";
const PoolInfo = () => {
  const [volumeModalOpen, setVolumeModalOpen] = useState(false);
  const openVolumeModal = () => setVolumeModalOpen(true);
  const closeVolumeModal = () => setVolumeModalOpen(false);

  const [liquidityModalOpen, setLiquidityModalOpen] = useState(false);
  const openLiquidityModal = () => setLiquidityModalOpen(true);
  const closeLiquidityModal = () => setLiquidityModalOpen(false);

  return (
    <>
      <div className="statsSN subcontent" data-aos="fade-up" data-aos-delay="500" data-aos-duration="600">
        <div className="d-flex justify-content-between gap-1">
          <div>
            <h2 className="gradient-stroke-text">UFO Pool</h2>
            <p>Monitor real-time UFO liquidity web data, including trading volume and total liquidity. Keep track of ecosystem activity and stay informed on the dynamic liquidity web and volume trends.</p>
            <div className="d-flex gap-3 mt-4 pt-2 mb-3">
            <button onClick={openVolumeModal} className="mybtn underline text-white p-0 cGold">
              <span>Volume</span>
            </button>
            <button onClick={openLiquidityModal} className="mybtn underline text-white p-0 cGold">
              <span>Liquidity </span>
            </button>
          </div>
          </div>
          <div>
          </div>
        </div>
      </div>

      <Volumepopup
        modalIsOpen={volumeModalOpen}
        closeModal={closeVolumeModal}
      />

      <Liquiditypopup
        modalIsOpen={liquidityModalOpen}
        closeModal={closeLiquidityModal}
      />
    </>
  );
};

export default PoolInfo;
